export default __webpack_public_path__ + "static/media/Metamask_Dark.879eef74.svg";